import Lottie from 'lottie-react';

import { pallete } from '@utils/animation';

import styles from './Pallet.module.scss';

export function Pallet() {
  return <Lottie animationData={pallete} loop={true} className={styles.pallet} />;
}
